// extracted by mini-css-extract-plugin
module.exports = {"placeholderGray":"#9297A3","borderGray":"#D3D6DC","fields":"fields-3yRqE","field":"field-3Z8hn","abbr":"abbr-1xOPD","spacer":"spacer-13hQo"};